import React from "react";
import { Building2, Handshake, ArrowUpRight } from "lucide-react";

const Owners = () => {
  return (
    <section
      id="owners"
      data-testid="owners-section"
      className="relative overflow-hidden bg-black py-28 md:py-36"
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute right-[-10%] top-1/2 h-[600px] w-[600px] -translate-y-1/2 rounded-full bg-orange-500/10 blur-[160px]" />
      </div>
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid items-center gap-14 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <p className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.28em] text-orange-400">
              For owners
            </p>
            <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-white sm:text-5xl">
              Own a tower, a fiber loop,<br />or rooftop? <span className="text-orange-400">Let’s talk.</span>
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-neutral-300">
              We work with independent owners, regional operators and family
              offices to bring liquidity, professional management, and a real
              investor audience to their assets — without losing the long-term
              upside.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a
                href="#early-access"
                data-testid="owners-cta"
                className="group inline-flex h-12 items-center gap-2 rounded-full bg-white px-7 text-sm font-semibold text-neutral-950 transition-all duration-300 hover:bg-orange-300"
              >
                Talk to the team
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
              <div className="text-xs uppercase tracking-[0.22em] text-neutral-500">
                NDA-friendly · No fee to list
              </div>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="grid grid-cols-2 gap-4">
              <Card
                icon={Building2}
                kicker="Asset class"
                title="Towers, fiber, rooftops, edge"
                tone="orange"
                testid="owner-card-asset"
              />
              <Card
                icon={Handshake}
                kicker="Structure"
                title="Joint-venture or full acquisition"
                tone="yellow"
                testid="owner-card-structure"
              />
              <Card
                kicker="Liquidity"
                title="Partial cash-out, keep the upside"
                tone="ghost"
                testid="owner-card-liquidity"
                big
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Card = ({ icon: Icon, kicker, title, tone = "ghost", testid, big }) => {
  const toneRing = {
    orange: "border-orange-500/30 bg-orange-500/5",
    yellow: "border-yellow-500/30 bg-yellow-500/5",
    ghost: "border-white/10 bg-neutral-950",
  }[tone];

  return (
    <div
      data-testid={testid}
      className={`relative overflow-hidden rounded-2xl border p-6 ${toneRing} ${big ? "col-span-2" : ""}`}
    >
      {Icon && (
        <div className="grid h-10 w-10 place-items-center rounded-xl border border-white/15 bg-black/50 text-white">
          <Icon className="h-5 w-5" />
        </div>
      )}
      <div className="mt-5 text-[10px] uppercase tracking-[0.22em] text-neutral-400">
        {kicker}
      </div>
      <div className="mt-2 font-display text-lg font-semibold text-white">
        {title}
      </div>
    </div>
  );
};

export default Owners;
